import { ZollSupportTicketConstants } from '../store/zollSupportTicket.constants'

export const zollSupportTicketSchemas = [
  {
    inputKey: ZollSupportTicketConstants.SET_EMAIL_ADDRESS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_EMAIL_ADDRESS: {
        type: 'string',
        pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
      },
    },
    additionalProperties: false,
    required: ['SET_EMAIL_ADDRESS'],
    errorMessage: {
      properties: {
        SET_EMAIL_ADDRESS: 'Must be in the format: email@example.com',
      },
    },
  },
  {
    inputKey: ZollSupportTicketConstants.SET_PHONE_NUMBER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHONE_NUMBER: {
        type: 'string',
        pattern: '^([2-9][0-9][0-9]-[2-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHONE_NUMBER'],
    errorMessage: {
      properties: {
        SET_PHONE_NUMBER: 'Must be in the format: NNN-NNN-NNNN',
      },
    },
  },
]
